import './index.css'

import cl from 'clsx'
import * as React from 'react'

type RowProps = {
  columnsSize: number[]
  // TODO: make `marginBottom` required
  marginBottom?: boolean | string
  alignCenter?: boolean
  children: React.ReactElement | null | Array<React.ReactElement | null>
  className?: string
} // TODO: remove passing arrays as props, potentially cause rerenders

/**
 * Grid row component that applies Bootstrap-style column sizing to children
 * Provides flexible column layout with configurable spacing and alignment
 * @param columnsSize - Array of column sizes for Bootstrap grid system
 * @param marginBottom - Whether to apply bottom margin, or 'small' for reduced margin
 * @param alignCenter - Whether to center-align the row content
 * @param children - Child elements to render in columns
 * @param className - Additional CSS classes to apply
 */
export default class Row extends React.Component<RowProps> {
  static defaultProps: {
    marginBottom: boolean
  } = {
    // TODO: make `marginBottom` opt-in, not opt-out
    marginBottom: true,
  }

  render(): React.ReactElement<'div'> {
    const { children, columnsSize, className } = this.props
    return (
      <div
        className={cl('row', className, {
          Row_NoMarginBottom: !this.props.marginBottom,
          Row_MarginBottomSmall: this.props.marginBottom === 'small',
          Row_AlignCenter: this.props.alignCenter,
        })}
      >
        {React.Children.map(children, (child, index) => {
          if (!child) return null
          if (typeof child !== 'object') return child
          const el = child as React.ReactElement<{ className?: string }>
          return React.cloneElement(el, {
            ...el.props,
            className: cl(el.props.className, `col-xs-${columnsSize[index]}`),
          })
        })}
      </div>
    )
  }
}
